import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "@/lib/anim";

const chapters = [
  {
    no: "01",
    title: "The chaos of running independent hospitality.",
    body: "Bookings live in WhatsApp. Menus in a notebook. Payments on scraps of paper. Every handover risks a double-booked room or a lost order.",
  },
  {
    no: "02",
    title: "One workspace, from arrival to invoice.",
    body: "StayFlow unifies rooms, tables, orders and billing into a single mobile-first system your whole team can trust — no training required.",
  },
  {
    no: "03",
    title: "Built for the real world — even offline.",
    body: "Spotty network in the hills or a busy Friday rush? StayFlow keeps working fully offline and quietly syncs the moment you reconnect.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" className="py-24 md:py-32 scroll-mt-24" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="overline text-brand"
        >
          Why StayFlow
        </motion.p>

        <div className="mt-14 md:mt-20 divide-y divide-black/10">
          {chapters.map((c) => (
            <motion.div
              key={c.no}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-100px" }}
              variants={stagger(0.1)}
              className="grid md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14"
            >
              <motion.div variants={fadeUp} className="md:col-span-3">
                <span className="font-heading font-extrabold text-6xl md:text-7xl text-brand/15">{c.no}</span>
              </motion.div>
              <motion.h3
                variants={fadeUp}
                className="md:col-span-5 font-heading font-bold text-2xl md:text-3xl text-ink tracking-tight leading-snug"
              >
                {c.title}
              </motion.h3>
              <motion.p variants={fadeUp} className="md:col-span-4 text-ink-soft text-lg leading-relaxed self-center">
                {c.body}
              </motion.p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
